import { CopyMediaFromMediaHouseDocument } from "@/generated/graphql";
import { useMutation } from "@apollo/client/react";

/** Copies a Media House asset into B2B, returning it in the shape slides store media in. */
export const useCopyFromMediaHouse = () => {
  const [copyMediaMutation, { loading: copying }] = useMutation(CopyMediaFromMediaHouseDocument);

  const copyFromMediaHouse = async (mediaHouseId: string, phonemeId?: string) => {
    const { data } = await copyMediaMutation({
      variables: { mediaHouseId, phonemeId },
    });

    const mediaAsset = data?.copyMediaFromMediaHouse;

    if (!mediaAsset) {
      throw new Error("Failed to copy media from Media House");
    }

    return {
      src: mediaAsset.url,
      id: mediaAsset.id,
      filename: mediaAsset.filename,
    };
  };

  return { copyFromMediaHouse, copying };
};
